import styled from 'styled-components';
import {dFlex, flexColumn, alignCenter, justifyBetween, alignStart, alignEnd, justifyCenter, flexWrap} from '../../../../../globalVariables/GlobalFlex.js';
import {getToken, getPrimitive, getSpacing, getFontWeight, getFontSize} from '@tickchak/react-share/app';

export const container = styled.div`
    ${dFlex}
    ${flexColumn}
    ${alignStart}
    gap: ${getSpacing('spaceLg')};
    width: 100%;
    padding: ${getSpacing('spaceXl')};
    height: 100%;
`;

export const sectionsWrapper = styled.div`
    ${dFlex}
    ${flexColumn}
    ${alignStart}
    gap: ${getSpacing('spaceLg')};
    width: 100%;
    padding: ${getSpacing('spaceLg')};
    background: ${getPrimitive('grays.gray100')};
    border-radius: ${getSpacing('spaceMd')};
`;
export const section = styled.div`
    ${dFlex}
    ${flexColumn}
    ${alignStart}
    gap: ${getSpacing('spaceLg')};
    width: 100%;
`;

export const sectionHeader = styled.div`
    ${dFlex}
    ${alignCenter}
    ${justifyBetween}
    width: 100%;
`;

export const titleWrapper = styled.div`
    ${dFlex}
    ${flexColumn}
    ${alignEnd}
    gap: ${getSpacing('spaceXs')};
    flex: 1;
`;

export const title = styled.h3`
    font-weight: ${getFontWeight('bold')};
    font-size: ${getFontSize('caption')};
    text-align: start;
    color: ${getToken('color.text.default')};
    width: 100%;
`;

export const subtitle = styled.p`
    font-weight: ${getFontWeight('regular')};
    font-size: ${getFontSize('caption')};
    text-align: start;
    color: ${getToken('color.text.default')};
    white-space: pre-wrap;
    width: 100%;
`;

export const inputsRow = styled.div`
    ${dFlex};
    ${alignCenter}
    ${justifyCenter}
    ${flexWrap}
    gap: ${getSpacing('spaceXl')};
    width: 100%;
`;

export const dateTimeColumn = styled.div`
    ${dFlex}
    ${flexColumn}
    gap: ${getSpacing('spaceXs')};
    flex: 1;
    position: relative;
`;

export const divider = styled.div`
    height: 1px;
    width: 100%;
    background: ${getPrimitive('grays.gray300')};
`;
